import { useEffect } from 'react'
import { getWsClient } from '@/lib/ws'

/**
 * Подписка на WS-комнату на время жизни компонента (docs/06 §8).
 * Клиент считает ссылки, поэтому две карточки одного бота не мешают друг другу.
 */
export function useWsRoom(room: string | null): void {
  useEffect(() => {
    if (room === null) return
    const client = getWsClient()
    if (client === null) return
    void client.subscribe(room).catch(() => {
      // Отказ подписки (нет прав / другая org) — не повод падать: REST уже
      // вернул 404, экран покажет «не найдено».
    })
    return () => client.release(room)
  }, [room])
}
